/**
 * Token 管理工具
 * token 为主站登录态，WordAppToken 为单词服务（voc-ielts）独立登录态
 */

import { notifyCrossTab } from './crossTabSync'

const TOKEN_KEY = 'token'
const WORD_TOKEN_KEY = 'WordAppToken'

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY)
}

export function saveToken(token: string) {
  localStorage.setItem(TOKEN_KEY, token)
  // 登录成功后通知同域名下其他窗口刷新，同步登录态
  if (token) notifyCrossTab('login')
}

export function getWordToken(): string | null {
  return localStorage.getItem(WORD_TOKEN_KEY)
}

export function saveWordToken(token: string) {
  localStorage.setItem(WORD_TOKEN_KEY, token)
  window.dispatchEvent(new CustomEvent('word-token-updated', { detail: token }))
}
